import {doc} from '../docs.js';
import * as THREE from "three";

doc(
    "three.orthographicCamera",
    {
        "left":"",
        "right":"",
        "top":"",
        bottom:"",
        near:"",
        far:""
    },
    "Create an orthographic camera ",
    undefined,
    {
        tags: "Graphics",
        isHot: true,
        inlets: 7,
        connects: {
            object: "three.render",
            inlet: "1"
        },
        operations: CAMERA_OPERATIONS
    }
);

const CAMERA_OPERATIONS = {
    position: {
        parameters: ['x', 'y', 'z'],
        description: 'Sets the position of the camera.'
    },
    lookAt: {
        parameters: ['x', 'y', 'z'],
        description: 'Sets where the camera is pointing'
    },
    zoom: {
        parameters: ['amount'],
        description: 'Sets the zoom of the camera'
    }
};

export const orthographicCamera = (object, left, right, top, bottom, near, far) => {
    let width = 300;
    let height = 300;
    object.needsStart = true;
    let camera = new THREE.OrthographicCamera(
        window.innerWidth / - 2, window.innerWidth / 2, window.innerHeight / 2, window.innerHeight / - 2, - 10000, 10000);
    camera.position.z = 0;
    camera.position.y = 0;
    camera.position.x = 0;
    return ([msg]) => {
        handlePosition(camera, msg);
        let _left = ni(left(), -1);
        let _right = ni(right(), 1);
        let _top = ni(top(), -1);
        let _bottom = ni(bottom(), 1);
        let _near = ni(near(), 1);
        let _far = ni(far(), 1);

        camera.left = _left;
        camera.right = _right;
        camera.top = _top;
        camera.bottom = _bottom;
        camera.far = _far;
        camera.near = _near;
        camera.updateProjectionMatrix();

        return camera;
    };
}


let tokenize = (str) => {
    let tokens = str.split(" ").filter(x => x !== "");
    return tokens.slice(1).map(x => parseFloat(x));
};

const handlePosition = (camera, msg) => {
    if (msg === "bang") {
        return false;
    }
    if (typeof msg === "string") {
        if (msg.startsWith("position")) {
            let [x,y,z] = tokenize(msg);
            camera.position.x = x;
            camera.position.y = y;
            camera.position.z = z;
            return true;
        } else if (msg.startsWith("lookAt")) {
            let [x,y,z] = tokenize(msg);
            camera.lookAt(x,y,z);
            return true;
        } else if (msg.startsWith("zoom")) {
            let [z] = tokenize(msg);
            camera.zoom = z;
            return true;
        }
    }
    return false;
};

doc(
    "three.perspectiveCamera",
    {
        "fov":"",
        "aspect":"",
        near:"",
        far:""
    },
    "Create a perspective camera ",
    undefined,
    {
        tags: "Graphics",
        isHot: true,
        inlets: 5,
        operations: CAMERA_OPERATIONS,
        connects: {
            object: "three.render",
            inlet: "1"
        },
    }
);

export const perspectiveCamera = (object, fov, aspect, near, far) => {
    let camera = new THREE.PerspectiveCamera(80, 1, 1, 10000);
    camera.position.z = 5;
    object.needsStart = true;

    return ([msg]) => {
        handlePosition(camera, msg);
        let _fov = ni(fov(), 80);
        let _aspect = ni(aspect(), 1);
        let _near = ni(near(), 1);
        let _far = ni(far(), 10000);

        camera.fov = _fov;
        camera.aspect = _aspect;
        camera.far = _far;
        camera.near = _near;
        camera.updateProjectionMatrix();
        return [camera];
    };
}

const ni = (x, y) => x === undefined ? y : x;

export const cameras = {
    "three.orthographicCamera": orthographicCamera,
    "three.perspectiveCamera": perspectiveCamera,
};
